module.exports = __webpack_public_path__ + "static/img/wxtci.d8e604a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wxtci.png
// module id = k4xo
// module chunks = 0